(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-mf-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const hero = document.querySelector('[data-section-type="accio-mf-hero"]');
  if (!hero) return;

  const content = hero.querySelector('[data-parallax-content]');
  const wrapper = document.querySelector('.page-wrapper') || window;

  function onScroll() {
    const scrollTop = wrapper.scrollTop !== undefined ? wrapper.scrollTop : window.scrollY;
    const heroHeight = hero.offsetHeight;
    if (scrollTop > heroHeight) return;
    const progress = scrollTop / heroHeight;
    if (content) {
      content.style.transform = 'translateY(' + (progress * 60) + 'px)';
      content.style.opacity = 1 - progress * 1.5;
    }
  }

  wrapper.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
